import Typography from '@components/atoms/Typography';
import SVGComponent from 'types/SVGComponent';
import CalendarIcon from 'assets/icons/calendar.svg';
import VatIcon from 'assets/icons/vat.svg';
import PercentIcon from 'assets/icons/percent.svg';
import ShieldIcon from 'assets/icons/shield.svg';
import PocketIcon from 'assets/icons/pocket.svg';
import HeadphoneIcon from 'assets/icons/headphone.svg';
import { FormattedMessage, MessageDescriptor } from 'utils/intl';
import getListWithId from 'utils/getListWithId';

import Proposal from './Proposal';
import messages from './Proposals.messages';
import classes from './Proposals.module.scss';

type Variant = 'complexDelivery' | 'publicSector';

type Item = {
  id: number;
  title: MessageDescriptor;
  subtitle: MessageDescriptor;
  icon: SVGComponent;
};

export type Props = {
  variant: Variant;
};

const titleMap: Record<Variant, MessageDescriptor> = {
  complexDelivery: messages.complexDeliveryTitle,
  publicSector: messages.publicSectorTitle,
};

const itemsMap: Record<Variant, Item[]> = {
  complexDelivery: getListWithId([
    {
      title: messages.pocketTitle,
      subtitle: messages.pocketSubtitle,
      icon: PocketIcon,
    },
    {
      title: messages.headphoneTitle,
      subtitle: messages.headphoneSubtitle,
      icon: HeadphoneIcon,
    },
  ]),
  publicSector: getListWithId([
    {
      title: messages.calendarTitle,
      subtitle: messages.calendarSubtitle,
      icon: CalendarIcon,
    },
    {
      title: messages.vatTitle,
      subtitle: messages.vatSubtitle,
      icon: VatIcon,
    },
  ]),
};

const constItems: Item[] = [
  {
    id: 3,
    title: messages.priceTitle,
    subtitle: messages.priceSubtitle,
    icon: PercentIcon,
  },
  {
    id: 4,
    title: messages.protectTitle,
    subtitle: messages.protectSubtitle,
    icon: ShieldIcon,
  },
];

const Proposals = ({ variant }: Props): JSX.Element => (
  <section>
    <Typography className={classes.title} variant="h1" renderAs="div" align="center">
      <FormattedMessage {...titleMap[variant]} />
    </Typography>
    <div className={classes.proposalsWrapper}>
      {[...itemsMap[variant], ...constItems].map(({ id, icon, subtitle, title: proposalTitle }) => (
        <Proposal
          key={id}
          title={<FormattedMessage {...proposalTitle} />}
          subtitle={<FormattedMessage {...subtitle} />}
          icon={icon}
        />
      ))}
    </div>
  </section>
);

export default Proposals;
